export default __webpack_public_path__ + "static/media/courseCatalogA.00239b60.png";